<template>
<div class="chapter">
<div class="inner_page">
<p class="right" id="tp"><a id="pagev"></a><span class="big1"><strong>The Second World War</strong></span><br/>A Complete History<br/><br/><br/><br/><br/><br/><br/><br/><br/></p>
<p class="right">Martin Gilbert</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?a871118c